import * as ents from '@attain-apps/entities'
import type * as router from '@attain-apps/fe/web/main/lib/router'

import type * as me from '../../../me'

import type { Feature } from './feature'
import * as models from './models'

export class Selectors {
  /** @see {@link models.page.Rendering.Context Context} */
  public readonly context
  /** TODO: */
  public readonly rendering
  /** Name of the {@link ents.core.mosaic.Page} */
  public readonly name

  /** TODO: */
  public readonly isRenderingLoading
  /** TODO: */
  public readonly renderingError

  /** TODO: */
  public readonly content

  /** TODO: */
  public readonly containers
  /**
   * Corresponds to {@link currentSegmentAliasInUrl}, if there is one. Otherwise, is
   * just the first item in {@link containers}
   */
  public readonly currentContainer
  /** @see {@link models.page.Rendering.hasQuery} */
  public readonly hasPageQuery
  /** TODO: */
  public readonly currentSegmentAliasInUrl
  /** TODO: */
  public readonly getSegmentUrl

  constructor(
    feature: Feature,
    meFeature: me.Feature,
    routerFeature: router.Router,
  ) {
    // NOTE: Edge case exists where selectedApp and selectedAppPage may become desynchronized
    this.context = meFeature.contexts.selectors.appContext.project(
      meFeature.contexts.selectors.app.asSelector,
      meFeature.contexts.selectors.appPage.asSelector,
      meFeature.contexts.selectors.scenarioContext.asSelector,
      (appContext, app, appPage, scenarioContext) => {
        // If any of the contexts are not available, we cannot create the
        // rendering context
        if (
          !appContext ||
          !app ||
          !appPage ||
          // NOTE: Skip context creation for prebuilt pages as they are handled
          // separately from the current-rendering feature
          ents.extra.prebuilt.Page.Id.isId(appPage.pageId)
        ) {
          return
        }

        return {
          ...appContext,
          appPageId: appPage.id,
          pageId: appPage.pageId,
          // If app support scenario use it as part of the context
          scenarioId:
            app.supportsScenarios && app.scenarios.length > 0
              ? scenarioContext?.scenarioId
              : undefined,
        }
      },
    )

    this.rendering = feature.state.project(state => state.rendering)
    this.name = this.rendering.project(rendering => rendering?.name)
    this.hasPageQuery = this.rendering.project(
      rendering => rendering?.hasQuery ?? false,
    )

    this.isRenderingLoading = feature.state.project(
      state => state.isRenderingLoading,
    )
    this.renderingError = feature.state.project(state => state.renderingError)

    /**
     * This mostly exists to ensure better memoization/efficiency
     */
    const rawContent = this.rendering.project(rendering => rendering?.content)
    this.content = rawContent.project(_rawContent =>
      _rawContent ? models.page.Content.from(_rawContent) : undefined,
    )

    this.currentSegmentAliasInUrl = routerFeature.selectors.fragment
    this.getSegmentUrl = feature.createSelectorMethod(
      ({ alias }: ents.core.common.Aliased) =>
        routerFeature.selectors.getUrlWith({ fragment: alias }),
    )

    this.containers = this.content.project(content =>
      content?.basic
        ? [content.basic]
        : (content?.scrolling ?? content?.tabbed ?? []),
    )
    this.currentContainer = this.containers.project(
      this.currentSegmentAliasInUrl.asSelector,
      (containers, alias) =>
        alias === undefined
          ? containers[0]
          : containers.find(container => container.alias === alias),
    )
  }
}
